module.exports = __webpack_public_path__ + "static/media/DoD Seal.c4c16d8a.PNG";